import React from "react"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"

const TotalLeadsChart = ({ leadChartData }) => {
  const series = [
    {
      name: "Total",
      data: Object.values(leadChartData?.total || []),
    },
    {
      name: "Sales",
      data: Object.values(leadChartData?.sales || []),
    },
    {
      name: "Purchase",
      data: Object.values(leadChartData?.purchase || []),
    },

  ]

  const options = {
    chart: {
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#556ee6", "#7b93eb", "#a8c5f7"],
    },

    colors: ["#556ee6", "#8ba4ed", "#c5d5f7"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: { title: { text: "Count" } },
    grid: {
      borderColor: "#f1f1f1",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return " " + val + " Count"
        },
      },
    },
  }

  return (
    <ReactApexChart options={options} series={series} type="bar" height={320} />
  )
}

export default TotalLeadsChart

TotalLeadsChart.propTypes = {
  leadChartData: PropTypes.array,
}
